import(/* webpackMode: "eager", webpackExports: ["AffiliateClickId"] */ "/opt/build/repo/app/_app-initialization/AffiliateClickId.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieSize"] */ "/opt/build/repo/app/_app-initialization/CookieSize.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/opt/build/repo/app/_providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/slick-carousel/slick/slick.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/slick-carousel/slick/slick-theme.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"public/fonts/geist.ts\",\"import\":\"Geist\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"]}],\"variableName\":\"geist\"}");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["DatadogInit"] */ "/opt/build/repo/observability/datadog/init.tsx");
